import { buildModuleInnerWrapperId, buildModuleWrapperId } from './classNameUtils';
import { isStyleOverridden, lookupCssValue, writeGridPositionToCss, writeJustifyOrAlignItemsToCss, writePadding } from './gridLayoutStyleUtils';
import { buildNodeSelector, isMediaQuery } from './combineBreakpointStyles';
import { isFitContentWidth, isSizedWidth } from 'layout-data-lib/GridLayoutDataTree/typenameUtils';
function writeEditorProvidedModuleStylesToCss(styles, stylesByBreakpointName) {
  Object.entries(styles.breakpointStyles).forEach(([breakpointName, style]) => {
    const stylesForBreakpoint = stylesByBreakpointName[breakpointName] || [];
    if (!stylesByBreakpointName[breakpointName]) {
      stylesByBreakpointName[breakpointName] = stylesForBreakpoint;
    }
    if (isStyleOverridden(style.gridPosition) || isStyleOverridden(style.gridSpanning)) {
      stylesForBreakpoint.push(writeGridPositionToCss(style.gridPosition, style.gridSpanning));
    }
    if (isStyleOverridden(style.flexGrow)) {
      stylesForBreakpoint.push(`flex-grow: ${style.flexGrow};`);
      stylesForBreakpoint.push(`flex-basis: 0;`);
    } else if (isStyleOverridden(style.width)) {
      if (isSizedWidth(style.width)) {
        stylesForBreakpoint.push(`width: ${style.width.size.value}${lookupCssValue(style.width.size.units)};`);
      } else if (isFitContentWidth(style.width)) {
        stylesForBreakpoint.push(`width: fit-content;`);
      }
    }
    if (isStyleOverridden(style.isHidden)) {
      stylesForBreakpoint.push(`display: ${style.isHidden ? 'none' : 'block'};`);
    }
    if (isStyleOverridden(style.padding)) {
      stylesForBreakpoint.push(writePadding(style.padding));
    }
    if (isStyleOverridden(style.zIndex)) {
      stylesForBreakpoint.push(`z-index: ${style.zIndex};`);
    }
    stylesByBreakpointName[breakpointName] = stylesForBreakpoint;
  });
  return stylesByBreakpointName;
}
function writeInnerWrapperEditorProvidedModuleStylesToCss(styles, innerWrapperStylesByBreakpointName) {
  Object.entries(styles.breakpointStyles).forEach(([breakpointName, style]) => {
    const stylesForBreakpoint = innerWrapperStylesByBreakpointName[breakpointName] || [];
    if (!innerWrapperStylesByBreakpointName[breakpointName]) {
      innerWrapperStylesByBreakpointName[breakpointName] = stylesForBreakpoint;
    }
    if (isStyleOverridden(style.verticalAlignment) || isStyleOverridden(style.horizontalAlignment)) {
      stylesForBreakpoint.push('display: flex;');
    }
    if (isStyleOverridden(style.verticalAlignment)) {
      stylesForBreakpoint.push(`align-items: ${writeJustifyOrAlignItemsToCss(style.verticalAlignment)};`);
    }
    if (isStyleOverridden(style.horizontalAlignment)) {
      stylesForBreakpoint.push(`justify-content: ${writeJustifyOrAlignItemsToCss(style.horizontalAlignment)};`);
    }
    innerWrapperStylesByBreakpointName[breakpointName] = stylesForBreakpoint;
  });
  return innerWrapperStylesByBreakpointName;
}
export default function writeModuleStylesToCss(nodeId, styles, breakpointConfigs) {
  const editorProvidedStyles = styles.editorProvidedModuleBreakpointStyles;
  if (!editorProvidedStyles) {
    return [];
  }
  const moduleWrapperSelector = buildModuleWrapperId(nodeId);
  const moduleInnerWrapperSelector = buildModuleInnerWrapperId(nodeId);
  const stylesByBreakpointName = {};
  const innerWrapperStylesByBreakpointName = {};
  writeEditorProvidedModuleStylesToCss(editorProvidedStyles, stylesByBreakpointName);
  writeInnerWrapperEditorProvidedModuleStylesToCss(editorProvidedStyles, innerWrapperStylesByBreakpointName);
  return breakpointConfigs.reduce((acc, config) => {
    const {
      breakpointName
    } = config;
    const breakpointStyles = stylesByBreakpointName[breakpointName];
    const innertWrapperBreakpointStyles = innerWrapperStylesByBreakpointName[breakpointName];
    if (breakpointStyles && breakpointStyles.length > 0) {
      const selector = buildNodeSelector({
        targetSelector: `#${moduleWrapperSelector}`,
        breakpointConfig: config
      });
      const mediaQuery = isMediaQuery(config) ? config.mediaQuery : '';
      acc.push([selector, breakpointStyles.join(' '), mediaQuery]);
    }
    if (innertWrapperBreakpointStyles && innertWrapperBreakpointStyles.length > 0) {
      const selector = buildNodeSelector({
        targetSelector: `#${moduleInnerWrapperSelector}`,
        breakpointConfig: config
      });
      const mediaQuery = isMediaQuery(config) ? config.mediaQuery : '';
      acc.push([selector, innertWrapperBreakpointStyles.join(' '), mediaQuery]);
    }
    return acc;
  }, []).filter(triple => triple !== null);
}